import React from "react";
import { Link } from "react-router-dom";

const AboutPage = () => {
  const stackTags = [
    "Next.js",
    "React",
    "Supabase",
    "Cloudflare",
    "Groq API",
    "Anthropic API",
    "Tailwind CSS",
    "Node.js",
    "Python",
    "Framer Motion",
  ];

  return (
    <div className="w-full bg-[#0f0f0f] text-[#f2f2f2] min-h-screen">
      <div className="max-w-[1100px] mx-auto px-5 py-[80px] md:py-[120px]">
        {/* Header */}
        <div className="mb-2">
          <span className="text-[11px] uppercase tracking-[0.12em] text-[#555555] border border-[#222222] px-3 py-1 rounded inline-block font-mono">
            ABOUT
          </span>
        </div>
        <h1
          className="text-[36px] sm:text-[48px] font-bold text-[#f2f2f2] mb-[40px]"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Builder. Not just a developer.
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-[80px]">
          {/* Main Editorial Text (Left 60% / 8 cols) */}
          <div className="md:col-span-8 space-y-6 text-[16px] text-[#cccccc] leading-[1.7]">
            <p>
              I'm Harshit, a product builder from India. I build AI tools, SaaS products, and web apps — mostly solo. I care about shipping fast and building things that actually work, not building things that look good in a pitch deck.
            </p>
            <p>
              I run FinishAI, an AI customer support chatbot platform. I'm also building Curvory — a pose reference PWA for artists. I document everything publicly on this site and on X (@harshitpraj).
            </p>
          </div>
        </div>

        <div className="w-full h-px bg-[#1a1a1a] mb-[60px]" />

        {/* What I work with */}
        <div className="mb-[80px]">
          <h2
            className="text-[20px] font-bold text-[#f2f2f2] mb-6"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            What I work with
          </h2>
          <div className="flex flex-wrap gap-x-6 gap-y-3 text-[14px] text-[#888888] font-mono">
            {stackTags.map((tech) => (
              <span key={tech} className="hover:text-white transition-colors">
                {tech}
              </span>
            ))}
          </div>
        </div>

        <div className="w-full h-px bg-[#1a1a1a] mb-[60px]" />

        {/* Current Focus */}
        <div className="mb-[80px]">
          <h2
            className="text-[20px] font-bold text-[#f2f2f2] mb-6"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Current Focus
          </h2>
          <div className="space-y-4 max-w-2xl">
            <div className="border-l-2 border-[#333333] pl-4 py-1 text-[15px] text-[#cccccc]">
              → Getting FinishAI to first paying customers
            </div>
            <div className="border-l-2 border-[#333333] pl-4 py-1 text-[15px] text-[#cccccc]">
              → Shipping Curvory v1 publicly
            </div>
            <div className="border-l-2 border-[#333333] pl-4 py-1 text-[15px] text-[#cccccc]">
              → Writing more on this blog
            </div>
          </div>
        </div>

        <div className="w-full h-px bg-[#1a1a1a] mb-[60px]" />

        {/* How to work with me */}
        <div>
          <h2
            className="text-[20px] font-bold text-[#f2f2f2] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            How to work with me
          </h2>
          <p className="text-[15px] text-[#888888] leading-relaxed mb-6 max-w-2xl">
            I'm open to collabs on AI products, consulting on fast-shipping strategy, and connecting with other builders. Not looking for employment.
          </p>
          <Link
            to="/contact"
            className="bg-transparent border border-[#333333] text-[#f2f2f2] px-[22px] py-[10px] rounded-[6px] text-sm hover:border-[#ffffff] transition-colors inline-block"
          >
            Let's Talk →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
